import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {ProductService} from '../../shared/product.service';
import {UiService} from '../../shared/ui.service';
import {ActivatedRoute} from '@angular/router';

interface FilterState {
  category: string | null; // 'Tous les produits' | 'Cheveux' | 'Coffrets' | 'Idées Cadeaux' | 'Maquillage' | 'Parfums' | 'Promotions' | 'Soins'
  subCategories: { name: string; selected: boolean; count?: number }[]; // families
  discounts: { name: string; selected: boolean; count?: number }[];
  brands: { name: string; selected: boolean; count?: number }[];
  filteredBrands: { name: string; selected: boolean; count?: number }[];
}

@Component({
  selector: 'app-sidebar-filters',
  templateUrl: './sidebar-filters.component.html',
  styleUrls: ['./sidebar-filters.component.scss'],
})
export class SidebarFiltersComponent implements OnInit {
  category: string | null = null;
  @Input() productsLength: number = 0;
  @Output() filterChange = new EventEmitter<FilterState>();
  unsubscribe$ = new Subject<void>();
  showFilters: any;

  subCategories: { name: string; selected: boolean; count?: number }[] = [];
  discounts: { name: string; selected: boolean; count?: number }[] = [
    { name: "Jusqu'à -30 %", selected: false },
    { name: 'de 31 % à -50 %', selected: false },
    { name: 'plus de 50 %', selected: false },
  ];
  brands: { name: string; selected: boolean; count?: number }[] = [];
  filteredBrands: { name: string; selected: boolean; count?: number }[] = [];
   categoryData: any; //filterOption
   families: { name: string; selected: boolean; count: number }[];
  private sousFamilies: void[];

  constructor(private productService: ProductService,
              private route: ActivatedRoute,
              public uiService: UiService) {}

  ngOnInit() {



    this.route.paramMap.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      const newCategory = params.get('category');
        this.category = newCategory;
        this.productService.getFilterOptions2()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(options => {
            const categoryData = options['categories'].find(cat => cat.category === this.category); //La categoriData

            this.families = categoryData.familles.map(name => ({
              name : name.famille,
              selected: false,
              count: 0
            }));
            this.brands = categoryData.marques.map(name => ({
              name,
              selected: false,
              count: 0
            }));
            console.log('Filter options:', this.categoryData);
            /* this.subCategories = options.sousFamilles.map(name => ({
               name,
               selected: name === 'Eau de Parfum',
               count: 0
             }));
             this.brands = options.marques.map(name => ({
               name,
               selected: false,
               count: 0
             }));
             this.filteredBrands = [...this.brands];*/
            this.emitFilterChange();
          });



    });

    this.uiService.filterVisibility$.pipe(takeUntil(this.unsubscribe$)).subscribe(visible => {
      this.showFilters = visible;
    });

  }

  filterBrands(searchTerm: string): void {
    this.filteredBrands = this.brands.filter(brand =>
      brand.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  onFilterChange(): void {
    this.emitFilterChange();
  }

  private emitFilterChange(): void {
    const filterState: FilterState = {
      category: this.category,
      subCategories: this.families,
      discounts: this.discounts,
      brands: this.brands,
      filteredBrands: this.filteredBrands
    };
    this.filterChange.emit(filterState);
  }

  toggleFilters(): void {
    this.uiService.toggleFilters();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
